import { render, staticRenderFns } from "./litelist.vue?vue&type=template&id=dd2ff552&scoped=true&"
import script from "./litelist.vue?vue&type=script&lang=js&"
export * from "./litelist.vue?vue&type=script&lang=js&"
import style0 from "./litelist.vue?vue&type=style&index=0&id=dd2ff552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2ff552",
  null
  
)

export default component.exports